<div fxLayout="row">
  <div fxFlex="93">
    <h2>{{ 'Legalization.SingleDocument' | translate : { documentType: data.DocumentTypeName } }}</h2>
  </div>
</div>
<div fxLayout="column" fxLayoutGap="10px">
  @for (f of data.LegalizationFiles; track f) {
    <div class="file" xLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
      <a href="javascript:void(0)" (click)="showFile(f)">{{ f.OriginalName ?? f.Name }}</a>
      <button mat-icon-button color="primary" (click)="downloadFile(f)">
        <mat-icon>download</mat-icon>
      </button>
    </div>
  }

  <button mat-raised-button (click)="onClose()" class="buttons-wrapper">
    {{ 'Cancel' | translate }}
  </button>
</div>
